import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import withState from "recompose/withState";
import withProps from "recompose/withProps";
import range from "lodash/range";
import DynamicBreadcrumbsNav from "./DynamicBreadcrumbsNav";
import withMedia from "../../../hocs/withMediaQueries";

const enhance = compose(
  withMedia,
  withState("isPickerOpen", "setIsOpen", false),
  withHandlers({
    onClickLetter: (props) => () => {
      props.setActivePage(props.bookmark.index + 1);
      props.setActiveNav(props.optionIndex);
      if (props.availableOptions) {
        props.setIsOpen(false);
      }
    },
    onClickChange: (props) => () => props.setIsOpen(true),
    onClickCancel: (props) => () => props.setIsOpen(false),
  }),
  withProps((props) => {
    return {
      isModal: props.media.fabletDown,
      isChangeable:
        props.isActive &&
        props.availableOptions &&
        props.availableOptions.filter((option) => option.available).length > 0,
      isPageActive: range(props.activePage - 4, props.activePage).includes(
        props.bookmark.index
      ),
    };
  })
);

export default enhance(DynamicBreadcrumbsNav);
